<template>
  <div class="bg_secondary ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xxl-6 col-lg-6">
          <div class="content-title style-five">
            <h6 class="section-subtitle" style="color: #9ca3af;">
              Franchise Terms and <span style="color: #e5e7eb;">Investment</span> Overview
            </h6>
            <h2 style="color: #b5ff00;">Franchise Fee Structure</h2>
            <p style="color: #e5e7eb;">The franchise fee is competitively set at $50,000 with a 10-year term, making this opportunity accessible for a premium quick-service restaurant brand.</p>
          </div>
        </div>
        <div class="col-xxl-5 offset-xxl-1 col-lg-6">
          <div class="fee-info">
            <div class="fee-item">
              <span class="fee-label">Franchise Term</span>
              <span class="fee-value">10 Years</span>
            </div>
            <div class="fee-item">
              <span class="fee-label">Franchise Fees</span>
              <span class="fee-value">$50,000</span>
            </div>
            <div class="fee-item">
              <span class="fee-label">Initial Investment</span>
              <span class="fee-value">$250K - $500K</span>
            </div>
            <div class="fee-item">
              <span class="fee-label">Liquid Capital Required</span>
              <span class="fee-value">$350,000+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseRequirements",
});
</script>

<style lang="scss" scoped>
.bg_secondary {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
}

.content-title {
  &.style-five {
    h6 {
      font-size: 14px;
      font-weight: 600;
      color: #9ca3af;
      margin-bottom: 10px;
      span {
        color: #e5e7eb;
      }
    }
    h2 {
      font-size: 32px;
      font-weight: 700;
      color: #f3f4f6;
      margin-bottom: 15px;
    }
    p {
      font-size: 16px;
      color: #e5e7eb;
      line-height: 1.6;
      margin-bottom: 0;
    }
  }
}

.fee-info {
  .fee-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 20px 25px;
    margin-bottom: 15px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      transform: translateY(-2px);
      border-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
      background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
    }
    .fee-label {
      font-size: 15px;
      font-weight: 600;
      color: #e5e7eb;
      display: flex;
      align-items: center;
      &:before {
        content: "";
        width: 8px;
        height: 8px;
        background-color: #9ca3af;
        border-radius: 50%;
        margin-right: 12px;
        display: inline-block;
      }
    }
    .fee-value {
      font-size: 18px;
      font-weight: 700;
      color: #f3f4f6;
      background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
      padding: 8px 16px;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.15);
      min-width: 120px;
      text-align: center;
    }
  }
}

@media only screen and (max-width: 767px) {
  .content-title {
    &.style-five {
      h2 {
        font-size: 24px;
      }
    }
  }
  .fee-info {
    .fee-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      .fee-value {
        font-size: 14px;
      }
    }
  }
}
</style>
